import axios from 'axios';
import serviceUtil from './serviceUtil';

let helpers = {
  markAllReadByProjectId: (projectId) => {
    return axios({
      method: 'patch',
      url:
      process.env.REACT_APP_API +
      '/alerts/' +
      '/mark_all_read_by_project_id?current_company=' +
      localStorage.current_company_id + 
      '&project_id=' + projectId,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;




// WEBPACK FOOTER //
// ./src/services/alertsService.js